import { Column } from 'react-table'
import GetUrls from 'ts/enums/Url'
import { ProductSubCategory } from 'ts/types/ProductSubCategory'
import CardTable from 'components/CardTable'
import ProductSubCategoryAddPage from './ProductSubCategoryAddPage'
import { Boolean as BooleanCell } from 'components/ui'

const columns: Column<ProductSubCategory>[] = [
  {
    Header: 'ID',
    accessor: 'subcategoryId'
  },
  {
    Header: 'Active',
    accessor: 'isActive',
    Cell: ({ value }) => <BooleanCell value={value} />
  },
  {
    Header: 'Sub Category',
    accessor: 'subcategoryName'
  }
]

const ProductSubCategoryPage = () => {
  const Url = GetUrls();
  return (
  <CardTable
    columns={columns}
    dataKey={Url.getSubcategory.toString()}
    url={Url.getSubcategory}
    listName={'subCategoryList'}
    modalChild={<ProductSubCategoryAddPage />}
  />
)}

export default ProductSubCategoryPage
